<template>
  <div class="d-flex justify-center mb-6 flex-wrap">
    <v-sheet class="ma-2 pa-2" v-ripple="{ class: `text-white` }">
      <p style="text-align: center;" class="text-h6 mt-5">
        東方蒼神縁起Vについてはこちら
      </p>
      <a href="https://wp.gensoukyou.org/souzinv/">
        <v-img src="../assets/titlelogo_v.png" width="300">
          <template #sources>
            <source srcset="../assets/titlelogo_v.webp" width="300" />
          </template>
        </v-img>
      </a>
    </v-sheet>
    <v-sheet class="ma-2 pa-2" v-ripple="{ class: `text-white` }">
      <p style="text-align: center;" class="text-h6 mt-5">
        東方幻想魔録Wについてはこちら
      </p>
      <a href="https://wp.gensoukyou.org/marokuw/">
        <v-img src="../assets/titlelogo_w.png" width="300">
          <template #sources>
            <source srcset="../assets/titlelogo_w.webp" width="300" />
          </template>
        </v-img> </a
    ></v-sheet>
  </div>
</template>
